import { RichTextElement } from "@redotech/redo-model/forge/review-forge-types";
import Quill from "quill";
import { useEffect, useRef, useState } from "react";
import { FormQuillEditorToolbar } from "../../form-builder/widget-editors/form-quill-editor-toolbar";
import {
  WidgetEditorProps,
  WidgetProps,
} from "../../form-builder/widget-editors/widget-editor-decorator";
import { WidgetElementEditor } from "../../form-builder/widget-editors/widget-element-editor";
import { convertToQuillHTML, QuillEditor } from "../../quill/quill-editor";

export const RichTextEditor = function RichTextEditor<
  T extends WidgetProps<RichTextElement>,
>(props: WidgetEditorProps<T, RichTextElement>) {
  const { element } = props.widget;

  const quillRef = useRef<Quill | null>(null);
  const [rerenderHelper, setRerender] = useState(false);
  const rerender = () => setRerender(!rerenderHelper);

  const containerId = `container-${element.id}`;
  const toolbarId = `toolbar-${element.id}`;

  useEffect(() => {
    if (
      quillRef.current &&
      element.html &&
      quillRef.current.getSemanticHTML() !== element.html
    ) {
      quillRef.current.root.innerHTML = convertToQuillHTML(element.html);
      rerender();
    }
    // FIXME
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quillRef.current, element.html]);

  return (
    <WidgetElementEditor {...props}>
      {(props) => (
        <div style={{ position: "relative" }}>
          <FormQuillEditorToolbar id={toolbarId} open={props.selected} />
          <style>
            {`
              #${containerId} a {
                color: ${element.linkColor};
              }
              #${containerId} div {padding: 0px;}
            `}
          </style>
          <QuillEditor
            editorId={containerId}
            editorStyles={{
              // styles must be declared here AND in the text element,
              // since the editor uses a totally separate component for rendering
              color: element.textColor,
              fontSize: element.fontSizePx,
              fontFamily: element.fontFamily,
              border: "none",
            }}
            onTextChange={(text) => {
              if (!quillRef.current) {
                return;
              }
              const html = quillRef.current.getSemanticHTML();
              if (element.html === html) {
                return;
              }
              props.setElement({ ...element, html: html });
            }}
            placeholder="Write here..."
            ref={quillRef}
            toolbar={toolbarId}
          />
        </div>
      )}
    </WidgetElementEditor>
  );
};
